import React, { Component } from 'react';

class EmptyCard extends Component {
  render() {
    return (
      <div className="p-1 w-32 h-16  ">

      </div>
    );
  }
}

export default EmptyCard;
